<zef-form
  [state]="state"
  (submit)="submit.emit()">

  @if (passwordIsSet) {
    <zef-form-field>
      <mat-form-field color="accent">
        <mat-label>{{ translations.currentPassword }}</mat-label>
        <zef-password-field>
          <input
            matInput
            type="password"
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.oldPassword"
          />
        </zef-password-field>
      </mat-form-field>
    </zef-form-field>
  }

  <zef-form-field>
    <mat-form-field color="accent">

      <mat-label>{{ passwordIsSet ? translations.newPassword : translations.password }}</mat-label>

      <zef-password-field>
        <input
          matInput
          type="password"
          name="new-password"
          [ngrxEnableFocusTracking]="true"
          [ngrxFormControlState]="state?.controls.newPassword"
        />
      </zef-password-field>

      <mat-hint class="__password-hint">

        @if (state?.controls.newPassword?.value?.length < 8) {
          {{ translations.minCharsHint }}
        }

        @if (state?.controls.newPassword?.value?.length > 72) {
          {{ translations.maxCharsHint }}
        }

        @if (state?.controls.newPassword?.value?.length >= 8 && state?.controls.newPassword?.value?.length < 12) {
          {{ translations.safetyCheckHint }}
        }

      </mat-hint>

    </mat-form-field>
  </zef-form-field>

  <ng-content />

</zef-form>
